import React from "react";
import "./Features.css";

const Features = () => {
  const features = [
    {
      icon: "⏰",
      title: "Smart Scheduling",
      description:
        "AI-powered reminders that learn your patterns and suggest optimal timing for tasks.",
    },
    {
      icon: "🧠",
      title: "Context Awareness",
      description:
        "Understands your location, calendar and habits to provide relevant reminders.",
    },
    {
      icon: "📱",
      title: "Multi-Platform Sync",
      description:
        "Seamlessly syncs across all your devices - phone, tablet, computer, and smartwatch.",
    },
    {
      icon: "🔔",
      title: "Smart Notifications",
      description:
        "Gentle, persistent reminders that adapt to your availability and preferences.",
    },
    {
      icon: "📋",
      title: "Task Management",
      description:
        "Organize tasks by priority, category and deadlines with intelligent suggestions.",
    },
    {
      icon: "🎯",
      title: "Goal Tracking",
      description:
        "Break down big goals into manageable tasks with automated progress reminders.",
    },
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="section-header">
          <h2>Why Choose Merabuddy?</h2>
          <p>
            Discover the features that make Merabuddy your perfect reminder
            companion
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <span>{feature.icon}</span>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
